import { type ComponentType, type FC, type ReactNode } from "react";

import { CancelledIcon, HideIcon, type IconProps, OfflineIcon, ShowIcon } from "@snapchat/snap-design-system-icons";

import { Visibility } from "../../gql-generated/types";

import {
    VisibilityDontPublishToSnapchatOption,
    VisibilityHiddenOption,
    VisibilityOfflineOption,
    VisibilityPublicOption,
} from "./VisibilityOptions";
import {
    VisibilityDoNotPublishToSnapchatDescription,
    VisibilityHiddenDescription,
    VisibilityOfflineDescription,
    VisibilityPublicDescription,
} from "./messages.generated";
import { type VisibilityOptionProps } from "./shared.types";

export const VISIBILITY_OPTION_MAP: Record<Visibility, FC<VisibilityOptionProps>> = {
    [Visibility.VisibilityUnset]: () => null,
    [Visibility.VisibilityHidden]: VisibilityHiddenOption,
    [Visibility.VisibilityOffline]: VisibilityOfflineOption,
    [Visibility.VisibilityPublic]: VisibilityPublicOption,
    [Visibility.VisibilityDontPublishToSnapchat]: VisibilityDontPublishToSnapchatOption,
};

export const VISIBILITY_OPTION_DESCRIPTION_MAP: Record<Visibility, ReactNode> = {
    [Visibility.VisibilityUnset]: null,
    [Visibility.VisibilityHidden]: <VisibilityHiddenDescription />,
    [Visibility.VisibilityOffline]: <VisibilityOfflineDescription />,
    [Visibility.VisibilityPublic]: <VisibilityPublicDescription />,
    [Visibility.VisibilityDontPublishToSnapchat]: <VisibilityDoNotPublishToSnapchatDescription />,
};

export const VISIBILITY_OPTION_LABEL_MAP: Record<Visibility, string> = {
    [Visibility.VisibilityUnset]: "",
    [Visibility.VisibilityHidden]: "Hidden",
    [Visibility.VisibilityOffline]: "Offline",
    [Visibility.VisibilityPublic]: "Public",
    [Visibility.VisibilityDontPublishToSnapchat]: "Do not publish to Snapchat",
};

export const VISIBILITY_OPTION_ICON_MAP: Record<Visibility, ComponentType<IconProps>> = {
    [Visibility.VisibilityUnset]: () => null,
    [Visibility.VisibilityHidden]: HideIcon,
    [Visibility.VisibilityOffline]: OfflineIcon,
    [Visibility.VisibilityPublic]: ShowIcon,
    [Visibility.VisibilityDontPublishToSnapchat]: CancelledIcon,
};
